import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./city-card-small.module.scss";
import CityCardButtons from "../city-card-buttons/city-card-buttons";
import { useAppDispatch } from "../../../../../hooks/useAppDispatch";
import { setOpenedCity } from "../../../../../services/reducers/cities";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import { City } from "../../../../../interfaces/city";
import { removeIndustrialCity } from "../../../../../utils/helpers-for-cities";
import { setCurrentOpenedCardPage } from "../../../../../services/reducers/filters";
import { LayersDataTypes } from "../../../../../types/layers-data-types";
import { setLayersVisible } from "../../../../../services/reducers/map";

export default function CityCardSmall({ city }: { city: City }) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openedCity } = useAppSelector((state) => state.cities);
  const { visibleLayersId, layersIds } = useAppSelector((state) => state.map);

  function openBigCard() {
    const cityBoundaryLayerIds = layersIds[LayersDataTypes.CityBoundary];

    if (Array.isArray(cityBoundaryLayerIds)) {
      const newVisibleIds = cityBoundaryLayerIds.filter(
        (id) => !visibleLayersId.includes(id),
      );

      if (newVisibleIds.length > 0) {
        dispatch(setLayersVisible([...visibleLayersId, ...newVisibleIds]));
      }
    }

    dispatch(setOpenedCity(city));
    dispatch(setCurrentOpenedCardPage("cities"));
  }
  const { cleanedName, wasRemoved } = removeIndustrialCity(city.name);

  return (
    <div
      id={`cities-closed-card-${city.estateEn}`}
      className={styles.cityCardSmall}
      onClick={openBigCard}
    >
      <div
        className={`${styles.cardHeader} ${openedCity?.estateEn == city.estateEn ? styles.active : ""}`}
      >
        <h3 className={styles.cardTitle}>
          {cleanedName}
          {wasRemoved && <span> {t("city-card.industrialCity")}</span>}
        </h3>
        <button className={styles.showDetailsButton}>
          <span>{t("city-card.showDetails")}</span>
        </button>
      </div>
      <CityCardButtons
        plotsAvailable={city.vacantPlots!}
        spacesForRentAvailable={city.spacesForRent!}
        investmentOpportunities={city.investmentPlots!}
        estateEn={city.estateEn}
        estateName={city.name}
      />
    </div>
  );
}
